<div class="container-layout">
  <!-- Left Section -->
  <div class="left-section">
    <div
      class="logo-container"
      [ngClass]="{ 'reduced-margin': isCurrentRoute('mfa-verify') }"
    >
      <img alt="Growth99 Logo" class="logo" [src]="g99ColoredLogo" />
    </div>
    <div class="router">
      <router-outlet />
    </div>
    <p class="copyright-text"> © 2025 Growth99. All rights reserved. </p>
  </div>

  <!-- Right Section: Image and Description -->
  <div class="right-section">
    <div class="background-image-section">
      <div class="image-container">
        <p class="description"
          >Powerful marketing automation to grow your practice</p
        >
      </div>
    </div>
  </div>
</div>
